import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';

const COLORS = [
  '#aa0b56',
  '#0088b0',
  '#5f3dc4',
  '#f59f00',
  '#006d8d',
  '#e67700',
  '#0c8599',
  '#7048e8',
  '#d6006c',
  '#15aabf',
  '#ae3ec9',
  '#edbb00',
];

interface Props {
  data: { category: string; sales: number }[];
  height?: number;
}

export const CategoryDonut = ({ data, height = 320 }: Props) => {
  const filtered = data
    .filter((d) => d.sales > 0)
    .map((d) => ({ name: d.category, value: d.sales }));
  return (
    <ResponsiveContainer width="100%" height={height}>
      <PieChart>
        <Pie
          data={filtered}
          dataKey="value"
          nameKey="name"
          innerRadius={60}
          outerRadius={110}
          paddingAngle={1}
          label={(p: { name?: string }) => p.name ?? ''}
        >
          {filtered.map((_, i) => (
            <Cell key={i} fill={COLORS[i % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip formatter={(v) => `¥${Number(v).toLocaleString()}`} />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
};
